// extracted by mini-css-extract-plugin
module.exports = {"banner":"_1TmOi","main":"_3lhRc","checkMore":"_1hAx1"};